import axios from "axios";
import { config_headers, servicelist, URL_API } from "../Config";

export const pContractorContractList = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();

            await axios.post(URL_API(`${servicelist.contractorService}p_contractor_contract_list`), body, authorization).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
